import request from '../../utils/request'

export const getRoleList = (data: RequestData) => {
  return request('getRoleList', {
    method: 'post',
    data,
  })
}

export const getRoleInfo = (data: RequestData) => {
  return request('getRoleInfo', {
    method: 'post',
    data,
  })
}

export const addRole = (data: RequestData) => {
  return request('addRole', {
    method: 'post',
    data,
  })
}

export const updateRole = (data: RequestData) => {
  return request('updateRole', {
    method: 'post',
    data,
  })
}

export const updateRoleResourceBind = (data: RequestData) => {
  return request('updateRoleResourceBind', {
    method: 'post',
    data,
  })
}

export const getEntityList = (data: RequestData) => {
  return request('getEntityList', {
    method: 'post',
    data,
  })
}

export const getAllArea = (data: RequestData) => {
  return request('getAllArea', {
    method: 'post',
    data,
  })
}

export const getEntityDetail = (data: RequestData) => {
  return request('getEntityDetail', {
    method: 'post',
    data,
  })
}

export const addEntity = (data: RequestData) => {
  return request('addEntity', {
    method: 'post',
    data,
  })
}

export const removeEntity = (data: RequestData) => {
  return request('removeEntity', {
    method: 'post',
    data,
  })
}

export const updateEntity = (data: RequestData) => {
  return request('updateEntity', {
    method: 'post',
    data,
  })
}

export const getAllResources = (data: RequestData) => {
  return request('getAllResources', {
    method: 'post',
    data,
  })
}

export const getEntityDefaultResources = (data: RequestData) => {
  return request('getEntityDefaultResources', {
    method: 'post',
    data,
  })
}

export const updateEntityResourceName = (data: RequestData) => {
  return request('updateEntityResourceName', {
    method: 'post',
    data,
  })
}

export const updateEntityRegisterCount = (data: RequestData) => {
  return request('updateEntityRegisterCount', {
    method: 'post',
    data,
  })
}
